import { Box } from '@mui/material'
import { Eye20Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import styles from './index.module.scss'

export default function UserChatBubbleReadReceipt() {
  return (
    <Box className={styles.readReceiptRow}>
      <Tooltip text="Seen" placement="top">
        <span className={styles.readReceiptIconWrap}>
          <Eye20Regular className={styles.readReceiptIcon} aria-hidden />
        </span>
      </Tooltip>
    </Box>
  )
}
